module.exports = __webpack_public_path__ + "media/boxes/box-full-of-pouches-excited-dog-927cdba1.svg";